<div class="chart-container">
    <div class="title mat-title">
        {{ data.details.scripName }}
    </div>

    <div class="stats full-width">
        <div class="display-flex full-width">
            <div class="label">Backtest P&L</div>
            <div class="spacer"></div>
            <div class="value" [ngClass]="{'text-positive': pnl >= '0', 'text-negative': pnl < '0'}">{{ pnl }}</div>
        </div>

        <div class="display-flex full-width">
            <div class="label">Max Drawdown</div>
            <div class="spacer"></div>
            <div class="value" [ngClass]="{'text-positive': maxDD >= '0', 'text-negative': maxDD < '0'}">{{ maxDD }}</div>
        </div>
    </div>

    <div echarts [config]="swiperConfig" *ngIf="chartsOptions" [options]="chartsOptions" class="pl-chart"></div>
</div>